<mat-icon class="icon">description</mat-icon>
<a lfwShouldOpenInNewTab [routerLink]="getLink()" role="link">
  <div class="doku">
    <div class="bigtext ordertext">{{ order().text }}</div>
    <div class="states">
      @if (getOrderStateText(); as orderStateText) {
        <div class="text state small-text" [style]="getOrderStateStyle()">{{ orderStateText }}</div>
      }
      @if (getSubStateText(); as subStateText) {
        <div class="text state small-text" [style]="getSubStateStyle()">{{ subStateText }}</div>
      }
      @if (getScenarioText(); as scenarioText) {
        <div class="text state small-text" [style]="getScenarioStyle()">{{ scenarioText }}</div>
      }
    </div>
  </div>
</a>

<lfw-online-order-list-actions
  [order]="order()"
  [userCanCancel]="userCanCancel"
  (finishOrder)="finishOrder()"
  (checkoutOrder)="checkoutOrder()"></lfw-online-order-list-actions>
